export enum TransactionOperationType {
  TRANSFER = 'TRANSFER',
  TRANSFERTOLOAN = 'TRANSFERTOLOAN',
  TRANSFERTOCREDITCARD = 'TRANSFERTOCREDITCARD',
}
